export enum SyncApi {
    Intern,
    Vitroconnect = 1,
    Authphone,
    MPS,
    GData,
    HostingDE,
    WaipuTV,
    CATV
}